import CheckoutOverlay from '../../../../../v2/components/CheckoutOverlay/CheckoutOverlay';
import SplititOverlayLazyLoader from './SplititOverlayLazyLoader';

function SplititOverlay() {
  return (
    <CheckoutOverlay
      popup
      nopadding
      fullscreenMobile
    >
      <SplititOverlayLazyLoader />
    </CheckoutOverlay>
  );
}

SplititOverlay.propTypes = {};

export default SplititOverlay;
